export const PAYNOTE_PLAID_SUCCESS_QUERY_PARAM = "paynote_plaid_success";
export const PAYNOTE_PLAID_CANCEL_QUERY_PARAM = "paynote_plaid_cancel"; 